import './HeaderNotifications.scss';

import { ArrowRightOutlined, NotificationFilled } from '@ant-design/icons';
import { Badge, Button, Empty, Popover } from 'antd';
import { Link } from 'react-router';

import { useUserContext } from '@/contexts/UserContext';

const HeaderNotifications = () => {
  const { notifications, unreadNotifications, markAsReadNotification } = useUserContext();
  const hasNotifications = (notifications?.length ?? 0) > 0;

  return (
    <div className="HeaderNotifications">
      <Popover
        rootClassName="NotificationListPopover"
        placement="bottomRight"
        content={
          notifications ? (
            <div className="HeaderNotificationsPanel">
              <div className="HeaderNotificationsHeader">
                <div className="HeaderNotificationsHeadings">
                  <p className="HeaderNotificationsLabel">Notificaciones</p>
                  <span className="HeaderNotificationsSubtitle">
                    {unreadNotifications > 0 ? `${unreadNotifications} sin leer` : 'Al dia'}
                  </span>
                </div>

                <Badge
                  className="HeaderNotificationsHeaderBadge"
                  count={unreadNotifications}
                  overflowCount={99}
                  size="small"
                />
              </div>

              {hasNotifications ? (
                <div className="HeaderNotificationsContent">
                  {notifications?.map(notification => (
                    <div
                      key={notification.id}
                      className={`NotificationItem ${notification.readed ? 'Readed' : 'Unreaded'}`}
                      tabIndex={0}
                      role="button"
                      onClick={() => {
                        if (!notification.readed) {
                          void markAsReadNotification(notification.id);
                        }

                        if (notification.url) {
                          window.open(notification.url, '_blank');
                        }
                      }}
                      onKeyDown={event => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          if (!notification.readed) {
                            void markAsReadNotification(notification.id);
                          }

                          if (notification.url) {
                            window.open(notification.url, '_blank');
                          }
                        }
                      }}>
                      <span className="NotificationItemAccent" aria-hidden />
                      <div className="NotificationItemBody">
                        <h4 className="NotificationItemTitle">{notification.title}</h4>
                        <p className="NotificationItemText">{notification.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="HeaderNotificationsEmpty">
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No hay notificaciones por ahora"
                  />
                </div>
              )}

              <div className="HeaderNotificationsFooter">
                <Link className="HeaderNotificationsViewAll" to="/notifications">
                  Ver todas <ArrowRightOutlined />
                </Link>
              </div>
            </div>
          ) : null
        }
        trigger="click">
        <Badge count={unreadNotifications} size="small">
          <Button
            className="HeaderNotificationsButton"
            icon={<NotificationFilled className="HeaderNotificationsButtonIcon" />}
            type="text"
          />
        </Badge>
      </Popover>
    </div>
  );
};

export default HeaderNotifications;
